import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useFormContext} from "react-hook-form";
import Emitter from "../../../EventEmitter/EventEmitter";
import {ConstantEventEmitter} from "../../../data/ConstantEventEmitter";
import {portafolioService} from "../../../services/apiPortafolios";
import {convertToString, validArray} from "../../../util/functions";
import {GlobalConstants} from "../../../data/GlobalConstants";
import {modalSideService} from "../../../services/modalSideService";
import {ConstantsFormCrud} from "../../../data/RoutesFormCrud";
import {isEmpty} from "../../../util/is";
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import Tooltip from "@mui/material/Tooltip";
import {Colors} from "../../../assets/colors/Colors";
import AgGridTable from "../../../components/AgGridTable";
import AccionesTable from "../../../components/AccionesTable";
import {modalCRUDService} from "../../../services/modalCRUDService";

const columnsDefPortafolios = [
  {headerName: 'Estado',field: "estado", cellRenderer: "indicadorEstado",resizable: true, sortable: true, filter: true, width: 50, headerCheckboxSelection: true, checkboxSelection: true},
  {headerName: 'Código',field: "id",resizable: true, sortable: true, filter: true, width: 100},
  {headerName: 'Portafolio Comercial',field: "portafolioComercial",resizable: true, sortable: true, filter: true, width: 150},
  {headerName: 'Total Portafolio Materiales',field: "totalPortafolioMateriales",resizable: true, sortable: true, filter: true, width: 100, editable: true},
  {headerName: 'Portafolios Materiales',field: "portafoliosMaterialInfo", cellRenderer: "tooltipCellComponent",resizable: true, sortable: true, filter: true, width: 200, editable: true},
  {headerName: 'Acciones',field: "acciones", cellRenderer: "accionesComponent", resizable: true, sortable: true, filter: true, width: 50},
  {headerName: 'jsSubportafolios',field: "jsSubportafolios", resizable: true, sortable: true, filter: true, width: 100, hide: true}
];

const AccionesPortafoliosComerciales = ({params}) => {

  return(
    <AccionesTable params={params} accionesBasicas={false} deleteAccion={false} otrasAcciones={
      <i onClick={() => Emitter.emit(ConstantEventEmitter.eventCrudModalTable, {params, type: ConstantEventEmitter.handleClickViewSubportafolios})} style={{color: Colors.COLOR_AMOVIL_BLUE_DARK, cursor: "pointer"}} className="far fa-eye fa-lg mx-1"/>
    } />
  )

}

const ExpandTablePortafoliosComerciales = ({properties}) => {

  const { getValues, dataList, tableRefMateriales} = properties;
  const tableRefPortafolios = useRef(null);
  const generalServicesState = useSelector( state => state.generalServices );

  const onCellValueChanged = params => {
    console.log(params)
  }

  const getRowStylePortafolios = params => {
    if(params.data.hide){
      return { 'display': 'none' };
    }
    else{
      return { 'display': 'flex' }
    }
  }

  const onRowDataChangePortafolios = params => {

    let countSelected = 0;
    let total = 0;

    params.api.forEachNode( (node) => {

      if(node.data.selected){
        countSelected++;
      }
      total++;

      node.setSelected(node.data.selected, false, true);

    })

    Emitter.emit(ConstantEventEmitter.handleUpdateCounterItemsPortafoliosComercial, {countSelected, total});


  }

  const onRowDataUpdatedPortafolios = params => {

    let countSelected = 0;
    let total = 0;
    params.api.forEachNode( (node) => {

      if(node.data.selected){
        countSelected++;
      }
      total++;

      node.setSelected(node.data.selected, false, true);

      console.log(node.data.hide)
      node.setRowHeight(node.data.hide ? 0 : 40);

    })

    params.api.onRowHeightChanged();

    Emitter.emit(ConstantEventEmitter.handleUpdateCounterItemsPortafoliosComercial, {countSelected, total});


  }

  const handleSave = () => {

    let arrData = [];
    tableRefPortafolios.current.api.forEachNode( (node) => {
      let data = node.data;
      data.selected = node.isSelected();
      arrData.push(data)
    })

    Emitter.emit(ConstantEventEmitter.eventUpdateDataPortafoliosComercialesFromModal, arrData);

    modalCRUDService.clear();

  }

  /*useEffect(() => {

    if(generalServicesState?.arrPortafolios?.length > 0){

      let objSubPortafoliosAllSelect = {};

      tableRefMateriales.current.api.forEachNode(node => {

        objSubPortafoliosAllSelect[node.data.id] = true;

      })

      let portafoliosMaterialSeleccionados = validArray(getValues("portafolioMaterial"));

      let arrPortafolios = validArray(generalServicesState?.arrPortafolios).slice();
      let arrUpdate = [];

      tableRefPortafolios.current.api.forEachNode( (node) => {

        let data = node.data;
        data.selected = node.isSelected();

        let portafolio = arrPortafolios.find(x => convertToString(x.id) === convertToString(node.data.id));
        let jsSubPortafolios = [];
        try{ jsSubPortafolios = JSON.parse(portafolio?.jsSubportafolios); }
        catch (e) { jsSubPortafolios = [];}

        let countTotalSubportafoliosByPortafolio = 0;
        let strSubPortafoliosExistentes = "";

        try{
          for(let itemSubPortafolio of jsSubPortafolios){
            if(objSubPortafoliosAllSelect[itemSubPortafolio.idSubportafolio]){
              itemSubPortafolio.checked = true;
              countTotalSubportafoliosByPortafolio++;
              strSubPortafoliosExistentes += `${itemSubPortafolio.idSubportafolio},`
            }
          }
        }
        catch (e) {}

        if(portafolio){

          let totalSubPortafoliosComerciales = validArray(jsSubPortafolios)?.length;
          let totalSubPortafoliosMateriales = validArray(portafoliosMaterialSeleccionados)?.length;

          data.jsSubportafolios = validArray(jsSubPortafolios);
          data.totalPortafolioMateriales = `${countTotalSubportafoliosByPortafolio}/${totalSubPortafoliosMateriales}`;
          data.portafoliosMaterialInfo = strSubPortafoliosExistentes.substring(0, strSubPortafoliosExistentes.length - 1);
          arrUpdate.push(data);

        }

      });


      if(arrUpdate.length > 0){
        tableRefPortafolios.current.api.applyTransaction({ update: arrUpdate });
      }

    }

  }, [generalServicesState])*/

  const onSelectionChangedPortafoliosComerciales = () => {

    let countSelected = 0;
    let total = 0;

    tableRefPortafolios.current.api.forEachNode(node => {
      if(node.isSelected()){
        countSelected++;
      }
      total++;
    });


    Emitter.emit(ConstantEventEmitter.handleUpdateCounterItemsPortafoliosComercial, {countSelected, total});

  }

  useEffect(() => {
    tableRefPortafolios.current.api.applyTransaction({ add: dataList });
  }, [dataList])

  return(
    <div className="w-100">

      <div className="w-100 d-flex justify-content-end align-items-center">

        <Tooltip title="Guardar" aria-label="guardar">
          <a onClick={() => handleSave()} className="icon-container-actions d-flex mr-0">
            <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
            <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
          </a>
        </Tooltip>

      </div>

      <div className="mt-0 w-100 d-flex align-items-center justify-content-between">
            <AgGridTable
              referencia= {tableRefPortafolios}
              columnDef = {columnsDefPortafolios}
              dataList = {[]}
              height = {500}
              getRowStyle={getRowStylePortafolios}
              rowSelection={'multiple'}
              suppressRowClickSelection={true}
              onRowDataUpdated={onRowDataUpdatedPortafolios}
              onRowDataChange={onRowDataChangePortafolios}
              onCellValueChanged={onCellValueChanged }
              onSelectionChanged={onSelectionChangedPortafoliosComerciales}
              acciones={AccionesPortafoliosComerciales}
            />

      </div>
    </div>
  )

}


export default ExpandTablePortafoliosComerciales;
